import React from "react";
import { bool, shape, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomData from "pages/_components/CustomData/CustomData";
import getCellPlacement from "../../../../util/helpers/table";
import CustomText from "pages/_components/CustomText/CustomText";

const EndorseItem = ({ isDesktop, item }) => {
    const alignX = isDesktop ? "center" : "left";
    const alignY = isDesktop ? "center" : "start";
    const getCellProps = (row, col) => getCellPlacement(row, col, { isDesktop });

    return (
        <>
            <GridTable.Data columnStart={1} alignX="left" rowStart={1}>
                <CustomData
                    titleText="echeqs.aval.request.email.solicitor.name"
                    titleTextType="I18N"
                    valueText={item?.emisor_razon_social}
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            <GridTable.Data alignX={alignX} alignY={alignY} rowWidth={1} {...getCellProps(1, 2)}>
                <CustomData
                    titleText="echeqs.aval.request.email.solicitor.document"
                    titleTextType="I18N"
                    valueText={item?.emisor_documento}
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            <GridTable.Data alignX="center" alignY={alignY} rowWidth={1} {...getCellProps(1, 3)}>
                {isDesktop ? (
                    <FormattedDate date={item?.fecha_hora} format="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="echecks.payedRange.label"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={item?.fecha_hora} format="DD/MM/YYYY" />}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>

            <GridTable.Data alignX={isDesktop ? "end" : "left"} alignY={alignY} rowWidth={1} {...getCellProps(1, 4)}>
                <CustomData
                    titleText="echeq.accept.return.status"
                    titleTextType="I18N"
                    valueText={"Anulado por acuerdo"}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
        </>
    );
};

EndorseItem.propTypes = {
    item: shape({}).isRequired,
    isDesktop: bool.isRequired,
};

export default EndorseItem;
